import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PortalLayoutsComponent } from './portal/portal-layouts/portal-layouts.component'
import { SignupComponent } from './signup/signup.component';
import { AdminLayoutsComponent } from './admin/admin-layouts/admin-layouts.component';
import { MdLayoutsComponent } from './md/md-layouts/md-layouts.component';
import {RouteResolver} from './resolvers/route.resover'
import {ServerDownComponent} from './server-down/server-down.component'
import { canActivateGuard, canMatchGuard } from './auth-gurad.service';
 
// import { NewSigninComponent } from './new-signin/new-signin.component';
import { SigninformComponent } from './signinform/signinform.component';
import { AmcsLayoutComponent } from './acms/amcs-layout/amcs-layout.component';

const routes: Routes = [
  // ************************************SIMRAN CODE START*********************************
  { path : "" , component: PortalLayoutsComponent , loadChildren:() => import('./portal/portal-layouts/portal-layouts.module').then( m => m.PortalLayoutsModule)},
  { path : "solution-admin" , component: AdminLayoutsComponent , canMatch: [canMatchGuard], loadChildren:() => import('./admin/admin-layouts/admin-layouts.module').then( m => m.AdminLayoutsModule)},
  { path : "md" , component: MdLayoutsComponent , canMatch: [canMatchGuard], loadChildren:() => import('./md/md-layouts/md-layouts.module').then( m => m.MdLayoutsModule)},
  { path : "acms" , component: AmcsLayoutComponent , canMatch: [canMatchGuard], loadChildren:() => import('./acms/amcs-layout/acms-layout.module').then( m => m.AcmsLayoutModule)},

  // **************************************SIMRAN CODE END*************************************
   
      {
          "path": "login",
          "component": SigninformComponent
      },
      {
          "path": "register",
          "component": SignupComponent
      },
      {
          "path": "**",
          "redirectTo": "error_404",
          "pathMatch": "full"
      },
      {
        "path": "error",
        "component": ServerDownComponent
    },
      {
        'path' : '' , 'redirectTo': 'index', 'pathMatch': 'full'
      }
  ];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  providers:[RouteResolver]
})
export class AppRoutingModule { }
